import React, {Component} from 'react';
import {FadeIn} from 'animate-components';

import About from './About';
import Experience from './Experience';
import Education from './Education';
import Skills from './Skills';
import Projects from './Projects';
import Contact from './Contact';

const tabs = [
   {
      value: 'About me',
      ref: 'about'
   }, {
      value: 'Experience',
      ref: 'experience'
   }, {
      value: 'Education',
      ref: 'education'
   }, {
      value: 'Skills',
      ref: 'skills'
   }, {
      value: 'Projects',
      ref: 'projects'
   }, {
      value: 'Contact',
      ref: 'contact'
   }
];

class Tab extends Component {
   constructor(props) {
      super(props);
      this.state = {
         isActive: ''
      }
   }

   componentWillMount() {
      this.props.currentTab === this.props.reference
         ? this.setState({isActive: 'active'})
         : this.setState({isActive: ''});
   }

   componentWillReceiveProps(nextProps) {
      if (this.props !== nextProps) {
         nextProps.currentTab === nextProps.reference
            ? this.setState({isActive: 'active'})
            : this.setState({isActive: ''});
      }
   }

   render() {
      return (
         <a
            onClick={this.props.onClick}
            className={`nav-item nav-link ${this.state.isActive} ${this.props.reference}`}
            href={`#${this.props.reference}`}
            id={this.props.reference}
            aria-controls={this.props.reference}>{this.props.value}</a>
      );
   }
}

class Navigation extends Component {
   constructor(props) {
      super(props);
      this.handleTabClick = this
         .handleTabClick
         .bind(this);
      this.state = {
         currentTab: 'about'
      }
   }

   handleTabClick = (clickedTab) => {
      this.setState({currentTab: clickedTab})
   }

   renderTabs(tabs) {
      const renderedTabs = tabs.map((tab, index) => {
         const {value, ref} = tab;
         return <Tab
            onClick={() => this.handleTabClick(ref)}
            currentTab={this.state.currentTab}
            key={index}
            reference={ref}
            value={value}/>;
      });
      return (
         <nav className="nav nav-pills nav-fill">
            {renderedTabs}
         </nav>
      )
   }

   showComponent(currentTab) {
      switch (currentTab) {
         case 'about':
            return <About/>
         case 'experience':
            return <Experience/>
         case 'education':
            return <Education/>
         case 'skills':
            return <Skills/>
         case 'projects':
            return <Projects/>
         case 'contact':
            return <Contact/>
         default:
            break;
      }
   }

   render() {
      return (
         <div>
            <FadeIn duration="1.2s" timingFunction="ease-out">
               {this.renderTabs(tabs)}
               {this.showComponent(this.state.currentTab)}
            </FadeIn>
         </div>
      );
   }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js